// extracted by mini-css-extract-plugin
export var standaloneTable = "_jr-0";
export var standaloneTableWithBodyFill = "_jr-1";
export var withExtraHeader = "_jr-2";